import React from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { Container, Nav, Navbar, Button, Modal } from 'react-bootstrap';
import { AuthProvider, useAuth } from './auth/AuthContext';
import ErrorBoundary from './ErrorBoundary';

const Navigation = () => {
  const navigate = useNavigate();
  const { role } = useAuth();
  const [showSessionModal, setShowSessionModal] = React.useState(false);

  const handleRevokeSession = () => {
    localStorage.clear();
    sessionStorage.clear();
    window.location.href = '/admin';
  };

  return (
    <>
      <Navbar bg="dark" variant="dark" expand="lg" fixed="top" className="w-100 shadow-sm" style={{ minWidth: '100vw', width: '100vw', maxWidth: '100vw', margin: 0, padding: 0, left: 0, right: 0 }}>
        <Container fluid style={{ padding: '0.5rem 1rem', width: '100%', maxWidth: '100%' }}>
          <Navbar.Brand style={{ cursor: 'pointer' }} onClick={() => navigate("/")} className="d-flex align-items-center">
            <img 
              src="/quvikme-logo.jpeg" 
              alt="QuVikme Logo" 
              style={{ 
                height: '40px', 
                width: '40px', 
                borderRadius: '50%',
                objectFit: 'cover'
              }}
            />
            <span className="ms-2" style={{ fontSize: '1.25rem', fontWeight: '500', color: 'white' }}>
              QuVikme
            </span>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto align-items-center">
              <Button 
                onClick={() => navigate("/")} 
                variant="light" 
                className="px-3 py-2 ms-2"
                style={{ fontWeight: '500' }}
              >
                Dashboard
              </Button>
              <Button 
                onClick={() => setShowSessionModal(true)} 
                variant="outline-info" 
                className="px-3 py-2 ms-2"
                style={{ fontWeight: '500' }}
              >
                Active Session
              </Button>
              <Button 
                onClick={() => navigate("/api-settings")} 
                variant="outline-light" 
                className="px-3 py-2 ms-2"
                style={{ fontWeight: '500' }}
              >
                API Settings
              </Button>
              <Button 
                onClick={() => navigate('/change-credentials')}
                variant="outline-light" 
                className="px-3 py-2 ms-2"
                style={{ fontWeight: '500' }}
              >
                Change Credentials
              </Button>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      <Modal show={showSessionModal} onHide={() => setShowSessionModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title className="h5 fw-bold">Active Admin Session Info</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p><strong>Role:</strong> {role || 'Super Admin'}</p>
          <p><strong>Device:</strong> {navigator.userAgent.substring(0, 60)}...</p>
          <p><strong>Status:</strong> <span className="text-success fw-bold">Active & Authenticated</span></p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowSessionModal(false)}>Close</Button>
          <Button variant="danger" onClick={handleRevokeSession}>Revoke Session & Logout</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

const ProtectedLayout = () => {
  const [isOffline, setIsOffline] = React.useState(!navigator.onLine);

  React.useEffect(() => {
    const handleOnline = () => setIsOffline(false);
    const handleOffline = () => setIsOffline(true);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    // 15-minute idle session timeout
    let timer;
    const resetTimer = () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        alert("Session expired due to 15 minutes of inactivity. Logging out.");
        localStorage.removeItem("adminToken");
        sessionStorage.removeItem("adminToken");
        localStorage.removeItem("QV_ADMIN_DOC_ID");
        sessionStorage.removeItem("QV_ADMIN_DOC_ID");
        window.location.href = "/admin";
      }, 15 * 60 * 1000);
    };

    const events = ["mousedown", "mousemove", "keydown", "scroll", "touchstart"];
    events.forEach((evt) => window.addEventListener(evt, resetTimer));
    resetTimer();

    return () => {
      clearTimeout(timer);
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
      events.forEach((evt) => window.removeEventListener(evt, resetTimer));
    };
  }, []);

  return (
    <AuthProvider>
      <ErrorBoundary>
        <div className="App d-flex flex-column min-vh-100">
          {isOffline && (
            <div
              className="bg-danger text-white text-center py-2 fixed-top"
              style={{ zIndex: 9999, fontWeight: "bold" }}
            >
              ⚠️ Network Connection Lost. You are currently offline.
            </div>
          )}
          <Navigation />
          <Container fluid className="flex-grow-1" style={{ padding: '1rem', paddingTop: '4rem' }}>
            <Outlet />
          </Container>
        </div>
      </ErrorBoundary>
    </AuthProvider>
  );
};

export default ProtectedLayout;